// Replace with your actual Firebase cloud function URL
export const LIVEKIT_TOKEN_ENDPOINT =
    "https://us-central1-wekruit-5f89b.cloudfunctions.net/generateLiveKitTokenWithAgentDispatch";

// Add additional configuration options here as needed
export const MODAL_AGENT_ENDPOINT =
    "https://wekruit-livekit-agents--consulting-faq-agent-start-consu-d75d5d.modal.run";
